import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import megaparkLogo from '../../assets/images/megapark.png';
import { toUrl } from '../../lib/config';

interface WelcomeModalProps {
  show: boolean;
  onHide: () => void;
  image?: string;
  title?: string;
  description?: string;
}

const WelcomeModal: React.FC<WelcomeModalProps> = ({ 
  show, 
  onHide,
  image,
  title = "Robotik Diz Cerrahisi",
  description = "Click to Watch the Video..."
}) => {
  // Image URL'ini düzenle
  const getImageSrc = () => {
    if (!image) return megaparkLogo;
    
    // Eğer /api/media/ ile başlıyorsa toUrl ile tam URL'e çevir
    if (image.startsWith('/api/media/')) {
      return toUrl(image);
    }
    
    return image;
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      backdrop="static"
      keyboard={true}
      className="welcome-modal"
    >
      <Modal.Body className="p-0 position-relative" style={{ borderRadius: '20px', overflow: 'hidden' }}>
        <button
          onClick={onHide}
          className="btn-close position-absolute"
          style={{ 
            top: '20px',
            right: '20px',
            zIndex: 10,
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            borderRadius: '50%',
            padding: '12px',
            width: '40px',
            height: '40px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            transition: 'all 0.3s ease'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = 'white';
            e.currentTarget.style.transform = 'scale(1.1)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.9)';
            e.currentTarget.style.transform = 'scale(1)';
          }}
          aria-label="Close"
        />
        
        <div 
          className="text-center position-relative"
          style={{
            background: 'linear-gradient(135deg, #2cadd2 0%, #1a8fb8 50%, #0d7a9e 100%)',
            padding: '60px 40px',
            minHeight: '500px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
            overflow: 'hidden'
          }}
        >
          {/* Decorative circles */}
          <div style={{
            position: 'absolute',
            top: '-50px',
            right: '-50px',
            width: '200px',
            height: '200px',
            borderRadius: '50%',
            background: 'rgba(255, 255, 255, 0.1)',
            filter: 'blur(40px)'
          }} />
          <div style={{
            position: 'absolute',
            bottom: '-80px',
            left: '-80px',
            width: '250px',
            height: '250px',
            borderRadius: '50%',
            background: 'rgba(255, 255, 255, 0.08)',
            filter: 'blur(50px)'
          }} />

          {/* Logo */}
          <div 
            className="mb-4"
            style={{
              animation: 'fadeInDown 0.8s ease-out',
              position: 'relative',
              zIndex: 1
            }}
          >
            <img 
              src={getImageSrc()} 
              alt="Megapark Hospital" 
              style={{
                maxWidth: '280px',
                height: 'auto',
                filter: 'drop-shadow(0 8px 16px rgba(0,0,0,0.2))',
                transition: 'transform 0.3s ease'
              }}
              crossOrigin="anonymous"
              onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
              onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
              onError={(e) => {
                // Hata olursa varsayılan logo'yu göster
                e.currentTarget.src = megaparkLogo;
              }}
            />
          </div>

          {/* Başlık */}
          <h2 
            className="text-white fw-bold mb-3"
            style={{
              fontSize: '2.8rem',
              textShadow: '0 4px 12px rgba(0,0,0,0.3)',
              letterSpacing: '0.5px',
              animation: 'fadeInUp 0.8s ease-out 0.2s both',
              position: 'relative',
              zIndex: 1
            }}
          >
            {title}
          </h2>

          {/* Açıklama */}
          <p 
            className="text-white mb-0"
            style={{
              fontSize: '1.2rem',
              opacity: 0.95,
              fontWeight: '300',
              letterSpacing: '0.3px',
              animation: 'fadeInUp 0.8s ease-out 0.4s both',
              position: 'relative',
              zIndex: 1
            }}
          >
            {description}
          </p>
        </div>
      </Modal.Body>

      <style>{`
        @keyframes fadeInDown {
          from {
            opacity: 0;
            transform: translateY(-30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .welcome-modal .modal-content {
          border-radius: 20px;
          border: none;
          box-shadow: 0 20px 60px rgba(0,0,0,0.3);
        }

        .welcome-modal .btn-close:hover {
          transform: scale(1.1);
        }

        .welcome-modal .btn-close:active {
          transform: scale(0.95);
        }
      `}</style>
    </Modal>
  );
};

export default WelcomeModal;
